import { render } from "./ThemeShowcase.vue?vue&type=template&id=6024df88&scoped=true&ts=true"
import script from "./ThemeShowcase.vue?vue&type=script&lang=ts"
export * from "./ThemeShowcase.vue?vue&type=script&lang=ts"

import "./ThemeShowcase.vue?vue&type=style&index=0&id=6024df88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6024df88"]])

export default __exports__